export const columnsForExport = [
  { label: "Facility", key: "facility_name" },
  { label: "Block", key: "block_name" },
  { label: "District", key: "district_name" },
  { label: "Open Date", key: "open_date" },
  { label: "Operational", key: "operational_attribute" },
  { label: "Total Meals", key: "total_meals" },
];
